// Chakra imports
import {
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  FormLabel,
  Input,
  Select,
  Textarea,
  IconButton,
  useToast,
} from "@chakra-ui/react";
import { AddIcon, CloseIcon } from "@chakra-ui/icons";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import TablesProductRow from "components/Tables/TablesProductRow";
import React, { useState } from "react";
import productService from "../../../../api/products/products";

const API_URL = process.env.REACT_APP_API_URL;

const Projects = ({ title, captions, data, categories }) => {
  const textColor = useColorModeValue("gray.700", "white");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const initialRef = React.useRef();
  const [productName, setProductName] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [features, setFeatures] = useState([""]);
  const [loading, setLoading] = useState(false);

  const handleAddFeature = () => {
    setFeatures([...features, ""]);
  };

  const handleRemoveFeature = (index) => {
    setFeatures(features.filter((_, i) => i !== index));
  };

  const handleFeatureChange = (index, value) => {
    const updatedFeatures = [...features];
    updatedFeatures[index] = value;
    setFeatures(updatedFeatures);
  };

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubmit = async () => {
    if (!productName.trim() || !selectedCategory || !description.trim() || !image) {
      toast({
        title: "Erreur",
        description: "Tous les champs obligatoires doivent être remplis.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const formData = new FormData();
    console.log(productName, selectedCategory, description, image)
    formData.append("name", productName);
    formData.append("category_id", selectedCategory);
    formData.append("description", description);
    formData.append("photo", image);
    features.forEach((feature, index) => {
      formData.append(`features[${index}]`, feature);
    });

    try {
      setLoading(true);
      const res = await productService.createProduct(formData);
      toast({
        title: "Succès",
        description: "Le produit a été créé avec succès.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      console.log(res)
      setProductName("");
      setSelectedCategory("");
      setDescription("");
      setImage(null);
      setFeatures([""]);
      onClose();
    } catch (error) {
      toast({
        title: "Erreur",
        description: error.response?.data?.message || "Une erreur est survenue.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
      <CardHeader p="6px 0px 22px 0px">
        <Flex direction="row" gap={5}>
          <Text fontSize="xl" color={textColor} fontWeight="bold">
            {title}
          </Text>
          {/* <Button
            w="50%"
            p="8px 32px"
            me="8px"
            colorScheme="orange"
            borderColor="#e2aa23"
            color="#e2aa23"
            variant="outline"
            fontSize="xs"
            onClick={onOpen}
          >
            Ajouter
          </Button> */}
          <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Créer un Produit</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <FormControl mb={4}>
                  <FormLabel>Nom du produit</FormLabel>
                  <Input
                    ref={initialRef}
                    placeholder="Nom du produit"
                    value={productName}
                    onChange={(e) => setProductName(e.target.value)}
                  />
                </FormControl>
                <FormControl mb={4}>
                  <FormLabel>Image</FormLabel>
                  <Input type="file" accept="image/*" onChange={handleImageChange} />
                </FormControl>
                <FormControl mb={4}>
                  <FormLabel>Catégorie</FormLabel>
                  <Select
                    placeholder="Choisissez une catégorie"
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                  >
                    {categories.map((category) => (
                      <option key={category.id} value={category.id}>
                        {category.name}
                      </option>
                    ))}
                  </Select>
                </FormControl>
                <FormControl mb={4}>
                  <FormLabel>Description</FormLabel>
                  <Textarea
                    placeholder="Description du produit"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </FormControl>
                <FormControl mb={4}>
                  <FormLabel>Caractéristiques</FormLabel>
                  {features.map((feature, index) => (
                    <Flex key={index} alignItems="center" mb={2}>
                      <Input
                        placeholder={`Caractéristique ${index + 1}`}
                        value={feature}
                        onChange={(e) => handleFeatureChange(index, e.target.value)}
                      />
                      {features.length > 1 && (
                        <IconButton
                          ml={2}
                          size="sm"
                          colorScheme="red"
                          icon={<CloseIcon />}
                          onClick={() => handleRemoveFeature(index)}
                        />
                      )}
                    </Flex>
                  ))}
                  {/* <Button
                    mt={2}
                    size="sm"
                    colorScheme="blue"
                    leftIcon={<AddIcon />}
                    onClick={handleAddFeature}
                  >
                    Ajouter une caractéristique
                  </Button> */}
                  <IconButton aria-label='Ajouter' onClick={handleAddFeature} icon={<AddIcon />} />
                </FormControl>
              </ModalBody>

              <ModalFooter>
                <Button
                  colorScheme="orange"
                  mr={3}
                  onClick={handleSubmit}
                  isLoading={loading}
                >
                  Créer
                </Button>
                <Button onClick={onClose}>Annuler</Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </Flex>
      </CardHeader>
      <CardBody>
        <Table variant="simple" color={textColor}>
          <Thead>
            <Tr my=".8rem" pl="0px" color="gray.400">
              {captions.map((caption, idx) => (
                <Th color="gray.400" key={idx} ps={idx === 0 ? "0px" : null}>
                  {caption}
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {data.map((row) => (
              <TablesProductRow
                key={`${row.id}-${row.name}`}
                id={row.id}
                image={`${API_URL}/${row.photo}`}
                name={row.name}
                categorie={row.category.name}
                createdAt={new Date(row.createdAt).toLocaleDateString("fr-FR", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              />
            ))}
          </Tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default Projects;
